import { FC, Fragment, useState, MouseEvent } from 'react'

import { useAuth } from 'oidc-react'

import { Box, Popover, Typography, IconButton, Button } from '@mui/material'

import AccountIcon from '@mui/icons-material/AccountCircle'

interface Props {

}

export const Profile: FC<Props> = () => {
    const auth = useAuth()

    const [anchorEl, setAnchorEl] = useState<Element | null>(null);

    const handleClick = (event: MouseEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        handleClose()
        auth.signOutRedirect()
    }

    return (
        <Fragment>
            <IconButton
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                color="inherit"
                onClick={handleClick}
            >
                <AccountIcon />
            </IconButton>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box
                    sx={{
                        p: 2.5,
                        height: 200,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography>Bienvenido</Typography>
                        <Typography>{auth.userData?.profile.name}</Typography>
                    </Box>
                    <Button variant='contained' color='primary' onClick={handleLogout}>Cerrar sesión</Button>
                </Box>
            </Popover>
        </Fragment>

    )
}
